"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Service Management Public REST API
 * Public REST API for Jira Service Management
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-a295e7484152fa2365a7ce8735dc664cc7adfec0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopeProjectToJSON = exports.ScopeProjectFromJSONTyped = exports.ScopeProjectFromJSON = exports.instanceOfScopeProject = exports.ScopeProjectProjectTypeKeyEnum = void 0;
const ProjectDetailsAvatarUrls_1 = require("./ProjectDetailsAvatarUrls");
const ProjectDetailsProjectCategory_1 = require("./ProjectDetailsProjectCategory");
/**
 * @export
 */
exports.ScopeProjectProjectTypeKeyEnum = {
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business'
};
/**
 * Check if a given object implements the ScopeProject interface.
 */
function instanceOfScopeProject(value) {
    return true;
}
exports.instanceOfScopeProject = instanceOfScopeProject;
function ScopeProjectFromJSON(json) {
    return ScopeProjectFromJSONTyped(json, false);
}
exports.ScopeProjectFromJSON = ScopeProjectFromJSON;
function ScopeProjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'avatarUrls': json['avatarUrls'] == null ? undefined : (0, ProjectDetailsAvatarUrls_1.ProjectDetailsAvatarUrlsFromJSON)(json['avatarUrls']),
        'id': json['id'] == null ? undefined : json['id'],
        'key': json['key'] == null ? undefined : json['key'],
        'name': json['name'] == null ? undefined : json['name'],
        'projectCategory': json['projectCategory'] == null ? undefined : (0, ProjectDetailsProjectCategory_1.ProjectDetailsProjectCategoryFromJSON)(json['projectCategory']),
        'projectTypeKey': json['projectTypeKey'] == null ? undefined : json['projectTypeKey'],
        'self': json['self'] == null ? undefined : json['self'],
        'simplified': json['simplified'] == null ? undefined : json['simplified'],
    };
}
exports.ScopeProjectFromJSONTyped = ScopeProjectFromJSONTyped;
function ScopeProjectToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'avatarUrls': (0, ProjectDetailsAvatarUrls_1.ProjectDetailsAvatarUrlsToJSON)(value['avatarUrls']),
        'id': value['id'],
        'projectCategory': (0, ProjectDetailsProjectCategory_1.ProjectDetailsProjectCategoryToJSON)(value['projectCategory']),
    };
}
exports.ScopeProjectToJSON = ScopeProjectToJSON;
//# sourceMappingURL=ScopeProject.js.map